// for idea see https://github.com/stefalda/react-localization/issues/68#issuecomment-374144675

import { enStrings } from './en';
import { deStrings } from './de';

export const localSettings: object = new Object({
    en: enStrings,
    de: deStrings
});
